import React, { useState, useEffect, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Box, {
    Item
} from 'devextreme-react/box';
import { Button } from 'devextreme-react/button';
import DataGrid, { Column, Lookup, Editing, Button as ButtonGrid } from 'devextreme-react/data-grid';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import http from '../../utils/http';
import SelectBox from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import { CheckBox } from 'devextreme-react/check-box';
import BlockHeader from '../shared/BlockHeader';
import { initialStateExtendCiclo, initialStateExtendPrisma, initialStateExtendSubj } from '../../data/graduacionesInit';
import { primsaImage } from '../../data/logo';
import { useSelector, useDispatch } from 'react-redux';
import { updateContactologia } from '../../store/contactologia/contactologiaReducer';
import Form from 'devextreme-react/form';
import { esferas, cilindros, ejes, reChanges, equivalencia,baseCurve, diameters } from '../../utils/custom';
import useAuthorization from '../../hooks/useAuthorization';
import { dataAccess, resources } from '../../data/app';
import notify from 'devextreme/ui/notify';
import { createStoreLocal } from '../../utils/proxy';
import { catalogosConocidos } from '../../data/catalogos';

const Nuevo = props => {

    const defaultArray = [{...initialStateExtendSubj, eye:'OD'},{...initialStateExtendSubj, eye:'OI'}];

    const { auth } = useAuthorization([resources.editarGraduaciones, dataAccess.access]);

    const dispatch = useDispatch();

    const refGridLenses = useRef();

    const [contactLenses, setContactLenses] = useState([...defaultArray]);   
    const [data, setData] = useState({brandId: null, modelId: null, observation : '', nextDateRecord: null, type:"esfera"});

    const [references, setReferences] = useState([]);
    const [corrections, setCorrections] = useState([]);
    const [marcasModelos, setMarcasModelos] = useState({
        marcas:[],
        modelos:[],
    });
    const [saving, setSaving] = useState(false);

    const { clientId, id, open } = useSelector(store => store.contactologia);

    const statusEditorRender = (cell) => {

        let _onValueChanged = onValueChanged.bind(this, cell);
        return <SelectBox
            searchEnabled={true}
            defaultValue={(cell.value == '' || cell.value == undefined) ? '0.00' : cell.value}
            {...cell.column.lookup}
            itemRender={itemRender}
            onValueChanged={_onValueChanged}
        />;

    }

    const itemRender = (data) => {

        return <div>
            <span className={data.value < 0 ? "negative" : ""}>{data.text}</span>
        </div>;
    }

    const itemRenderImage = (data) => {
        let imageSource = primsaImage;
        return <div>
            {imageSource}
            <span>{data.text}</span>
        </div>;
    }

    const onValueChanged = (cell, e) => {
        cell.setValue(e.value);
    }

    const onValueChangedImage = (cell, e) => {
        cell.setValue(e.value);
    }

    const onCellPrepared = e => {

        if (e.rowType == 'data') {

            if (e.column.dataField == "sphere")
                if (e.data.sphere < 0)
                    e.cellElement.classList.add('negative');

            if (e.column.dataField == "cylinder")
                if (e.data.cylinder < 0)
                    e.cellElement.classList.add('negative');

            if (e.column.dataField == "convertion")
                e.cellElement.classList.add('convertion-text');

            if (e.column.dataField == "correction"){

                if (e.data.correction < 0)
                    e.cellElement.classList.add('negative');
                e.cellElement.classList.add('correction-text');
            }


        }

    }

    const onValueChangedDataObs = (e) => {
        setData({ ...data, observation: e.value })
    }

    const onValueChangedDataDate = (e) => {
        setData({ ...data, nextDateRecord: e.value })
    }

    const guardarGrabacion = (params) => {

        let _uri = uri.contactLenses(clientId);

        refGridLenses.current.instance.saveEditData();
      
        let record = {
            ...data,
            id: data.id || 0,
            clientId: clientId,
            ContactLenses: [...contactLenses],
        }

        setSaving(true);
        http(_uri.insert).asPost(record).then(x => {

            setSaving(false);
            const { reload } = props;
            let result = reload?.();
            onHiding();

        }).catch(err => {

            setSaving(false);
            notify(err, 'error');

        });
    }

    const onHiding = (e) => {
        dispatch(updateContactologia({ open: false, clientId: 0, id: 0 }))
    }

    useEffect(() => {

        const contactLensesRest = ({ contactLenses, ...rest }) => rest;

        Promise.all([
            http('contactLenses/get/reference').asGet(),
            http('contactLenses/get/correcion').asGet(),
            http(uri.catalogEntries(catalogosConocidos.MarcaLenteContacto)).asGet(),
            http(uri.catalogEntries(catalogosConocidos.ModeloLenteContacto)).asGet(),
        ]).then(resp => {

            setReferences(resp[0]);
            setCorrections(resp[1]);
            setMarcasModelos({
                marcas: [...resp[2]],
                modelos: [...resp[3]]
            });

        });

        if (id > 0){

            http(uri.contactLenses().getById(id)).asGet().then(resp => {
                
                let response = contactLensesRest(resp);
                
                setData(response);
                setContactLenses([...resp.contactLenses]);
                
            });
        }else {
            if (open){
                
                setData({brandId: null, modelId: null, observation : '', nextDateRecord: null, type:"esfera"});
                setContactLenses([...defaultArray]);
            }
        }

    }, [open]);

    const findReference = (sphere, cylinder) => ref => parseFloat(ref.cilinder).toFixed(2) == cylinder && parseFloat(ref.sphere).toFixed(2) == sphere;

    const setCellValue = (prop, newData, value, currentRowData) => {
        newData[prop] = value || 0;
        if ((prop == 'sphere' || prop == 'cylinder') && value) {

            let cylinder = currentRowData['cylinder'];
            let sphere = currentRowData['sphere'];

            if (prop == 'sphere') {
                sphere = value;
                cylinder = currentRowData['cylinder']
            }

            if (prop == 'cylinder') {
                cylinder = value;
                sphere = currentRowData['sphere'];
            }

            if (cylinder && sphere) {

                const _fn = findReference(sphere, cylinder);
                const result = references.find(_fn);

                if (result) {
                    newData['convertion'] = result.value
                }
            }
        }

        if (prop == 'correction' && value) {
          
            const valueIsPositive = parseFloat(value) >= 0;
            
            let newValue = value;
            
            let correcion = corrections.find(x => x.correction == Math.abs(value));

            if(correcion){

                let valueSphere = valueIsPositive ? correcion.positivo : correcion.negativo; 
                newValue =  valueIsPositive ? `+${parseFloat(valueSphere).toFixed(2)}` : `-${parseFloat(valueSphere).toFixed(2)}`;

            }

            newData['sphere'] = newValue;
         
        }
    }

    const defaultValue = data.type || "esfera";

    const isEsferico = data.type == "esfera";

    const canEdit = auth.toEdit || id == 0;   

    return (
        <div>
            <Popup
                width={880}
                height={500}
                title={`Datos Contactológicos`}
                visible={open}
                onHiding={onHiding}
            >
                <BlockHeader title={`Lentes de contacto ${data.type == 'esfera' ? 'esferico' : 'tórico'}`}></BlockHeader>
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={3}>
                        <div className="option">
                            <span>Tipo:</span>
                            <SelectBox items={[{ id: 'esfera', name: 'Esferico' }, { id: 'torico', name: 'Tórico' }]}
                                onValueChanged={e => {
                                    setData({ ...data, type: e.value });
                                    setContactLenses([{ ...initialStateExtendSubj, eye: 'OD' }, { ...initialStateExtendSubj, eye: 'OI' }]);
                                }}
                                value={data.type}
                                defaultValue={defaultValue}
                                displayExpr="name"
                                valueExpr="id" />
                        </div>
                    </Item>
                    <Item ratio={1}></Item>
                    <Item ratio={1}>
                    </Item>
                </Box>
                <div>

                </div>
                <br/>   
            
                <DataGrid
                    ref={refGridLenses}              
                    dataSource={contactLenses}

                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}
                    onCellPrepared={onCellPrepared}
                >
                    <Editing
                        mode="cell"
                        allowUpdating={canEdit}
                    ></Editing>
                    <Column dataField="eye" width={60} caption='Rx' allowSorting={false} allowEditing={false} />
                    <Column dataField="correction" caption="Correcion anteojo/Conversion" setCellValue={setCellValue.bind(null, "correction")}
                        visible={isEsferico}
                        allowFiltering={false}
                        allowSorting={false} editCellRender={statusEditorRender} alignment='center'>
                        <Lookup dataSource={esferas} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column cssClass="eraseColumn" width="6"/>
                    <Column dataField="sphere" caption="Esfera" setCellValue={setCellValue.bind(null, "sphere")}
                        allowEditing={!isEsferico}
                        width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center'>
                        <Lookup dataSource={esferas} valueExpr="value" displayExpr="text" />
                    </Column>
                    
                    <Column dataField="cylinder" visible={!isEsferico} caption="Cilindro" setCellValue={setCellValue.bind(null, "cylinder")} width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center' >
                        <Lookup dataSource={cilindros} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="axis" visible={!isEsferico} caption="Eje" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={ejes} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="diameter" caption="Diametro" allowFiltering={false} allowSorting={false} alignment='center' >
                        <Lookup dataSource={diameters} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="baseCurve" caption="Curva Base" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={baseCurve} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="reChange" caption="Recambio" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={reChanges} valueExpr="value" displayExpr="text" />
                    </Column>
                    <Column dataField="convertion" caption="Convercion" allowEditing={false} allowFiltering={false} allowSorting={false} alignment='center' visible={!isEsferico} />
                </DataGrid>
                <br />
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={2}>
                        <div>
                            <span>Marca:</span>
                            <SelectBox 
                                dataSource={marcasModelos.marcas}
                                onValueChanged={e => {
                                    setData({ ...data, brandId: e.value });
                                    
                                }}
                                value={data.brandId}
                                displayExpr="value"
                                valueExpr="id" />
                        </div>
                    </Item>
                    <Item ratio={3}>
                        <div className="ml-10">
                            <span>Modelo:</span>
                            <SelectBox
                                dataSource={marcasModelos.modelos.filter(x => x.parentId == data.brandId)}
                                onValueChanged={e => {
                                    setData({ ...data, modelId: e.value });
                                }}
                                value={data.modelId}
                                displayExpr="value"
                                valueExpr="id" />
                        </div>
                    </Item>
                </Box>
                <br />
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={3}>
                        <div className="option">
                            <span>Observacion:</span>
                            <TextBox value={data.observation} placeholder="Observacion" onValueChanged={onValueChangedDataObs} disabled={!canEdit}></TextBox>
                        </div>
                    </Item>
                    <Item ratio={1}></Item>
                    <Item ratio={1}>
                        <div className="option">
                            <span>Próx. graduación:</span>
                            <DateBox value={data.nextDateRecord} openOnFieldClick={true} disabled={!canEdit} displayFormat='dd/MM/yyyy' onValueChanged={onValueChangedDataDate}></DateBox>
                        </div>
                    </Item>
                </Box>
                <br />
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={4}></Item>
                    <Item ratio={1}>
                        <Button className="btn-header-menu" icon="save"
                            text={`${saving ? 'Guardando...' : 'Guardar'}`}
                            disabled={saving}
                            type='default' onClick={guardarGrabacion} visible={canEdit} />
                    </Item>
                </Box>
            </Popup>
        </div>
    );
}

export default Nuevo;
